// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutShippingSectionStyles } from "@rpsc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import { constants } from "@rpsc/XDL/constants";
import IconEdit from "@rpsc/XDL/Icons/IconEdit";
import SavedAddresses from "@rpsc/XDL/Icons/SavedAddresses";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutShippingSectionStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: auto auto;
        justify-content: space-between;
        ${xScreen("lte", constants.onePageCheckout.tablet)} {
            display: flex;
            flex-direction: column;
        }
    `,
};
onePageCheckoutShippingSectionStyles.pickUpGridItem = {
    css: css`
        grid-column: 2 / 3;
        width: 432px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        ${xScreen("lte", constants.onePageCheckout.tablet)} {
            width: 100%;
            order: 2;
        }
        @media print {
            width: 40%;
            float: left;
        }
    `,
};
onePageCheckoutShippingSectionStyles.billToGridItem = {
    css: css`
        grid-column: 1 / 2;
        width: 432px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lte", constants.onePageCheckout.tablet)} {
            width: 100%;
            margin-bottom: 24px;
        }
        @media print {
            width: 100%;
        }
    `,
};

onePageCheckoutShippingSectionStyles.titleText = {
    variant: "h6",
    css: css`
        margin: 0;
    `,
};

onePageCheckoutShippingSectionStyles.shipToGridItem = {
    css: css`
        grid-column: 2 / 3;
        width: 432px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
        @media print {
            width: 100%;
        }
    `,
};

onePageCheckoutShippingSectionStyles.saveButtonGridItem = {
    css: css`
        grid-column: 2 / 3;
        justify-content: space-between;
        align-items: center;
        display: flex;
        margin-top: 16px;
        width: 432px;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

onePageCheckoutShippingSectionStyles.useShippingAddressGridItem = {
    css: css`
        margin-block: 4px;
        display: flex;
        width: 100%;
    `,
};

onePageCheckoutShippingSectionStyles.subTitleContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 24px;
    `,
};

onePageCheckoutShippingSectionStyles.changeLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        lineHeight: "17px",
    },
};

onePageCheckoutShippingSectionStyles.titleGridItem = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;
        margin-bottom: 16px;
        grid-column: 1 / 3;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

onePageCheckoutShippingSectionStyles.saveButton = {
    css: css`
        margin-left: auto;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};

onePageCheckoutShippingSectionStyles.title = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

onePageCheckoutShippingSectionStyles.editLink = {
    ...createLinkIconStyles(IconEdit),
};

onePageCheckoutShippingSectionStyles.notify = {
    css: css`
        margin: 0;
        max-width: 100%;
    `,
};
